

<template>
  <div class="homepage">


    <!-- 1. Hero Section - Carousel -->
    <div id="heroCarousel" class="carousel slide custom-border" data-bs-ride="carousel">
      <div class="carousel-inner">
         <!-- Slide 1 -->
        <div class="carousel-item active">
        <div class="carousel-image bg-image-1 d-flex align-items-center justify-content-center text-white text-center">
        <div class="bg-dark bg-opacity-50 p-4 rounded">
          <h1 class="display-6">Welcome to StepEdge Academy</h1>
          <p class="fs-5">Empowering the learning of Computer Science</p>
        </div>
      </div>
    </div> 

     <!-- Slide 2 -->
    <div class="carousel-item">
      <div class="carousel-image bg-image-2 d-flex align-items-center justify-content-center text-white text-center">
        <div class="bg-dark bg-opacity-50 p-4 rounded">
          <h1 class="display-6">Start Your Learning Journey</h1>
          <p class="fs-5">Build skills in critical & computational thinking, and real-world projects</p>
        </div>
      </div>
    </div>


    </div>
      
   
      <button class="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon"></span>
      </button>
    </div>
    <BaseContainer>
    <!-- 2. Quick Overview of Offerings -->
    <section  class="bg-light text-green  container my-5">
      <h1 class="display-6 text-center">Our Academic Offerings</h1>
      <div class="row text-center">
        <div class="col-md-4 mb-3" v-for="(item, index) in offerings" :key="index">
          <div class="card shadow-sm h-100 offering-card">
            <div class="card-body">
              <h5 class="card-title offering-card-title">{{ item.title }}</h5>
              <p class="card-text">{{ item.description }}</p>
              <a :href="item.link" class="btn btn-outline-success btn-sm">Learn More</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 3. Why Choose Us -->
    <section class="bg-white">
      <div class="container text-center feature-box why-section">
        
        <div class="row">
          <div class="col-md-3" v-for="(point, index) in strengths" :key="index">
            <i :class="point.icon + ' fs-1 text-success'"></i>
            <h6 class="mt-3 feature-title">{{ point.title }}</h6>
            <p class="text-muted small feature-description">{{ point.text }}</p>
          </div>
        </div>
        <div class="text-center mt-3">
          <h1 class="display-6">Why Choose Us?</h1>
            <a href="/teaching" class="btn btn-outline-success mt-3">Read more</a>
          </div>
      </div>
       
    </section>

    <!-- 4. Testimonials -->
    <section class="container my-5">
      <h2 class="text-center display-6">Student Testimonials</h2>
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="bg-light card p-4 text-center">
            <blockquote class="blockquote mb-0">
              <p>"Helped me improve my general and in-depth knowledge regarding to pseudocode and python..."</p>
              <footer class="blockquote-footer mt-2">iGCSE Student</footer>
            </blockquote>
            <div class="text-center mt-3">
            <a href="/testimonials" class="btn btn-outline-success mt-3">Read more</a>
          </div>
          </div>
          
        </div>
      </div>
    </section>

    <!-- 5. Call to Action / Jumbotron -->
    <section class="bg-success text-white py-5">
      <div class="container text-center">
        <h4>Ready to Take the Next Step?</h4>
        <p class="lead">Whether you're preparing for GCSEs, A-level or exploring IB options, we're here to help you succeed.</p>
        <router-link to="/contact" class="btn btn-light mt-3 contact-button">Contact Us</router-link>
      </div>
    </section>
</BaseContainer>


  </div>
</template>

<script>
import BaseContainer  from '@/components/BaseContainer.vue';
export default {
  name: 'HomePage',
  components: {
      BaseContainer,  
  },
  data() {
    return {
      offerings: [
        {
          title: 'StepEdge Digital Ecosystem',
          description: 'Building computational thinking at the system level — and that’s where real-world tech innovation happens...!',
          link: '/digital-learning-ecosystem'
        },
        {
          title: 'Constructing & Cultivating Computational thinking',
          description: 'GCSE/iGCSE, A-Level & IB  ',
          link: '/computational-thinking'
        },
        {
          title: 'Artifical Intelligence',
          description: 'Understand and apply the core concepts, algorithms...',
          link: '/artificial-intelligence'
        }
      ],
      strengths: [
        {
          title: 'Qualified Tutors',
          text: 'Every tutor is certified and experienced.',
          icon: 'bi bi-person-check'
        },
        {
          title: 'Flexible Sessions',
          text: 'Evening & weekend availability.',
          icon: 'bi bi-clock-history'
        },
        {
          title: 'Online + In-person',
          text: 'Join from anywhere or visit us locally.',
          icon: 'bi bi-laptop'
        },
        {
          title: 'Progress Tracking',
          text: 'Regular updates & parent feedback.',
          icon: 'bi bi-graph-up-arrow'
        }
      ]
    };
  }
};
</script>

<style scoped>
.carousel img {
  max-height: 300px;
  object-fit: cover;
}
.carousel {
  /*border: 2px solid black; /* change to any color */
  /*border-radius: 10px;     /* optional: adds rounded corners */
}
.carousel.custom-border {
  border: 1px solid darkgray;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  filter: invert(1) brightness(0.3); /* Makes arrow dark */
  /* background-color: rgba(255, 255, 255, 0.6); Optional: adds light background */
 /*  //border-radius: 50%; Optional: round background */
}

.bg-pale-green {
  background-color: lightgray;
  color: black;
}

.offering-card-title {
 
  color: darkgreen;
}
.offering-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}


.feature-box {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.feature-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
}
.why-section {
  background-color:  #f8f9fa; /* Very light gray *//* Very light gray */
  /* border-top: 1px solid #dce1e5;*/
}

.contact-button {
  background-color: white;
  color: green;
}

.feature-title {
  font-weight: 600;
  color: #222;
}

.feature-description {
  color: #555;
  font-size: 0.95rem;
}

/* Below CSS is for the logo StepEdge Academy */
.logo-container {
  font-family: 'Poppins', sans-serif;
}

.step-edge {
  font-size: 1.5rem;
  color: #33691e; /* dark green */
  position: relative;
}

.first-letter {
  font-size: 1.75rem;
  font-weight: 500;
}

.academy {
  font-size: 1.2rem;
  color: #66bb6a; /* light green */
  letter-spacing: 0.3rem;
  margin-top: 0.5rem;
}

/* Line Step Effect */
.line-step {
  position: absolute;
  left: 2.7rem; /* adjust depending on font size */
  top: -0.8rem;
  width: 3.5rem;
  height: 3rem;
  border-left: 2px solid #66bb6a;
  border-top: 2px solid #66bb6a;
  border-bottom: 2px solid #66bb6a;
  border-right: none;
  transform: rotate(0deg);
}

/* END CSS for the logo StepEdge Academy */


.carousel-image {
  height: 60vh;
  background-size: cover;
  background-position: center;
}

.bg-image-1 {
  background-image: url('@/assets/images/slider/susan-unsplash-2.jpg'); /* Replace with your image */
}
.bg-image-2 {
  background-image: url('@/assets/images/slider/photo-tutoring-121.avif'); /* Change to your image */
}
</style>
